import { Component } from '@angular/core';
import { Firestore, collection, query, where, getDocs, doc, updateDoc } from '@angular/fire/firestore';
import { AdminService } from '../services/admin.service';

import { lastValueFrom } from 'rxjs';
import { Gift } from '../services/model/gift';

@Component({
  selector: 'app-qr-reader',
  templateUrl: './qr-reader.component.html',
  styleUrls: ['./qr-reader.component.scss']
})
export class QrReaderComponent {
  scannedCode: string | null = null;
  subscriberId: string | null = null;
  subscriberUsed: boolean = false;
  error: string | null = null;
  infoMessage: string | null = null;
  selectedDevice: any = null;
  scannerEnabled = false;

   subscriberCoupons: string[] = [];

  purchaseAmount: number | null = null;
  giftNumber: Gift | null = null;

  beepAudio = new Audio('/assets/beep.mp3');

  gifts: Gift[] = [
    {
      name: 'Gratulálunk! Nyertél egy ajándék cserepes orchideát, amit azonnal át is vehetsz!',
      imgSrc: 'assets/images/orchidea.jpg',
      remaining: 0
    },
    {
      name: 'Egy 10%-os kupont nyertél, amit beválthatsz a következő vásárlásodnál!',
      imgSrc: 'assets/kupon.png',
      remaining: 0
    },
    {
      name: '30% kedvezményt nyertél egy minimum 10.000 Ft értékű csokorra!',
      imgSrc: 'assets/images/peaonia.jpg',
      remaining: 0
    },
    {
      name: 'Gratulálunk! Egy 10.000 Ft értékű ajándék virágbox lett a tiéd!',
      imgSrc: 'assets/images/viragdoboz.jpg',
      remaining: 0
    },
    {
      name: 'Ajándék kinti cserepes növényt nyertél 5000 Ft értékben!',
      imgSrc: 'assets/images/balkon.jpg',
      remaining: 0
    }
  ];


  constructor(private afs: Firestore, private adminService: AdminService) {}

  startScanner() {
    this.resetState();
    this.scannerEnabled = true;
  }

  stopScanner() {
    this.scannerEnabled = false;
  }

  onCodeResult(resultString: string) {
    if (!this.scannerEnabled) return;

    this.scannedCode = resultString;
    this.beepAudio.play();
    this.stopScanner();
    this.fetchSubscriberData(resultString);
  }

  async fetchSubscriberData(qrCodeValue: string) {
    this.adminService.fetchSubscriberByQr(qrCodeValue).subscribe({
      next: (data) => {
        this.subscriberId = data.id;
        this.subscriberUsed = data.used === true;
        this.subscriberCoupons = data.coupons;


        if (this.subscriberUsed) {
          this.infoMessage =
            'A kuponod ebben a kampányban már felhasználásra került. Ne csüggedj, mert hamarosan újra aktíváljuk kuponod és esélyed lehet újabb ajándékra is!';
        } else {
          this.infoMessage = null;
        }

        this.error = null;
      },
      error: (err) => {
        this.subscriberId = null;
        this.subscriberUsed = false;
        this.error = err.error || 'Hiba történt az adatlekérés során.';
        this.infoMessage = null;
        console.error(err);
      },
    });
  }


  async drawGift() {
    if (!this.scannedCode) {
      this.error = 'Először olvass be egy QR kódot!';
      return;
    }

    if (this.subscriberUsed) {
      this.error = 'Ez a kupon már fel lett használva.';
      return;
    }

    if (!this.purchaseAmount || this.purchaseAmount <= 0) {
      this.error = 'Kérlek, adj meg egy pozitív vásárlási összeget!';
      return;
    }

    this.error = null;
    this.infoMessage = null;

    try {
      const result = await lastValueFrom(
        this.adminService.drawGift(this.scannedCode, this.purchaseAmount, this.subscriberCoupons[0])
      );

      // Ajándék sorsolás itt (frontend oldalon történik továbbra is)
      this.giftNumber = this.gifts[Math.floor(Math.random() * this.gifts.length)];
      this.infoMessage = `Sikeres sorsolás! A nyeremény: ${this.giftNumber.name}`;
      this.subscriberUsed = true;
    } catch (err: any) {
      this.error = err?.error ?? 'Hiba történt a sorsolás során.';
      console.error(err);
    }
  }


  camerasFoundHandler(cameras: MediaDeviceInfo[]) {
    if (cameras && cameras.length > 0) {
      this.selectedDevice = cameras[0];
    }
  }

  resetState() {
    this.scannedCode = null;
    this.subscriberId = null;
    this.subscriberUsed = false;
    this.error = null;
    this.infoMessage = null;
    this.purchaseAmount = null;
    this.giftNumber = null;
    this.subscriberCoupons = [];
  }
}
